import { render, staticRenderFns } from "./SeatableDetailsModal.vue?vue&type=template&id=6bc67150"
import script from "./SeatableDetailsModal.vue?vue&type=script&lang=js"
export * from "./SeatableDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports